<template>
  <div class="product-detail-item">
    <label class="product-detail-item__label">{{ label }}</label>
    <div
      :class="[
        'product-detail-item__value',
        { 'product-detail-item__value--label': isLabel }
      ]"
      v-html="value"
    >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      // required: true,
    },
    value: {
      type: [String, Number],
      // required: true,
    },
    isLabel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.product-detail-item {
  &__label {
    font-weight: 700;
  }

  &__value {
    color: var(--order-line-color, #333);
    line-height: 1.6;

    &--label {
      display: inline-block;
      border-radius: 50px;
      padding: 0 10px;
      background: #e6f6ef;
      color: #36b079;
    }

    ::v-deep {
      p {
        margin-bottom: 0.5em;
      }

      ul, ol {
        margin: 0.5em 0;
        padding-right: 20px;
      }

      h1, h2, h3, h4, h5, h6 {
        margin: 0.5em 0;
        font-weight: 600;
      }

      a {
        color: $primaryColor;
        text-decoration: underline;
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>